export const contactNumber = '083 659 9943';
export const emailAddress = 'dean@steadfastprojects.co.za';